// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// init Swiper:
/*const initSliders = () =>{
    const sliders = document.querySelectorAll('.ume-intra-slider-block');
    if(sliders.length > 0){
        sliders.forEach(slider => {
            let next = slider.querySelector('.swiper-button-next');
            let previous = slider.querySelector('.swiper-button-prev');
            let pagination = slider.querySelector('swiper-pagination');
        })
    }
}*/
const swiper = new Swiper('.ume-intra-slider-block.swiper', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 4
    },
    slidesPerView: 1.025,
    spaceBetween: 15,
    breakpoints: {
        819: {

            slidesPerView: 2,
            spaceBetween: 30,

        },
        1181: {
            slidesPerView: 3,
            spaceBetween: 50,
        }
    },
    on: {
        lock: function () {

            this.el.classList.add('ume-intra-slider-block-locked');
        },
        unlock: function () {
            this.el.classList.remove('ume-intra-slider-block-locked');
        },
    },
});
